export default __webpack_public_path__ + "static/data-vis-categorical-chart-light-dfeeb371bcf44420422b13c79a73215f.png";